const CustomAlertIcon = (props) => {
    return <img src="/admin-images/tick-circle-success-alert.svg" alt="Custom Icon" {...props} />;
};

export default CustomAlertIcon;